
import React, { useState,  useEffect } from 'react';
import axios from 'axios';
import SockJS from 'sockjs-client';



const GetStudents = () => {
  const [videoUrl, setVideoUrl] = useState('');
  const [text, setText] = useState('');
  const [message, setMessage] = useState('');

  const handleInputChange = (e) => {
    setVideoUrl(e.target.value);
  };

  useEffect(() => {
    const sock = new SockJS('http://localhost:3001/api/endpoint');

    sock.onopen = () => {
      console.log('Connected to the server!');
    };

    sock.onmessage = (e) => {
      setMessage(e.data);
    };

    sock.onclose = () => {
      console.log('Disconnected from the server.');
    };

    return () => {
      sock.close();
    };
  });

  useEffect(() => {
console.log(message, "YOO")
  }, [message]);

  // const sendMessage = () => {
  //   sock.send('Hello from React!');
  // };

  const handleButtonClick = async () => {
    try {
      const response = await axios.post('http://localhost:3001/api/endpoint', { data: videoUrl });
  



      const sock = new SockJS('http://localhost:3001/api/endpoint');

      sock.onopen = () => {
        console.log('Connected to the server!');
      };
  
      sock.onmessage = (response) => {
        setMessage(response);
      };
  
      sock.onclose = () => {
        console.log('Disconnected from the server.');
      };
  
      return () => {
        sock.close();
      };







    } catch (error) {
      console.error('Error communicating with backend:', error);
      alert('Error communicating with backend');
    }
  };

  
  

  return (
    <div>
      <h1>Get Students</h1>
      <input
        type="text"
        value={videoUrl}
        onChange={handleInputChange}
        placeholder="Enter video URL"
      />
      <button onClick={handleButtonClick}>Submit</button>
    </div>
  );
};

export default GetStudents;
